export enum TUTORIALS_ADMIN {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452271
     */
    SLIDE_UPLOAD = 'ADMIN_MODULE_TUTORIAL_SLIDE_SETTINGS_UPLOAD',
}
